import { render } from "./AccountActivation.vue?vue&type=template&id=213a5ae8&scoped=true"
import script from "./AccountActivation.vue?vue&type=script&lang=ts"
export * from "./AccountActivation.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-213a5ae8"

export default script